define.alias("shared/components/shared/choose-your-upgrade/plan-card", "media/components/shared/choose-your-upgrade/plan-card");